
//for live
export const baseUrl="/nicdsign_registration/api/v1"
//for localhost
// export const baseUrl="http://localhost:8040/nicdsign_registration/api/v1"